import { Component, Input, OnInit } from '@angular/core'

import { EventService } from '../../../../shared/services/event.service'

@Component({
  selector: 'app-tools-catalogue-submenu',
  templateUrl: './tools-catalogue-submenu.component.html',
  styleUrls: ['./tools-catalogue-submenu.component.scss']
})
export class ToolsCatalogueSubmenuComponent implements OnInit {
  @Input() isToolSubNav?: boolean
  @Input() isMetricSubNav?: boolean

  currentPath: string

  constructor(private eventService: EventService) {}

  ngOnInit() {
    this.eventService.routeChanged.subscribe((route: { url: string }) => {
      this.currentPath = route.url
    })
  }
}
